// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M4,5v10.6C4,16.9,5.1,18,6.4,18h3.1l-1.1,4h1l1.1-4h2.7l1.2,4h1l-1.2-4h3.5c1.3,0,2.3-1,2.3-2.3V5H4z M19,15.7
		c0,0.7-0.6,1.3-1.3,1.3H6.4C5.6,17,5,16.4,5,15.6V6h14V15.7z M21,3v1H3V3H21z M12,16c2.5,0,4.5-2,4.5-4.5S14.5,7,12,7
		s-4.5,2-4.5,4.5l0,0C7.5,14,9.5,16,12,16z M11.5,8.1V11H8.6C8.8,9.5,10,8.3,11.5,8.1z M12.5,12V8c1.9,0.1,3.4,1.8,3.3,3.8
		S13.9,15.1,12,15c-1.7,0-3.2-1.3-3.4-3H12.5z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-presentation-C4DFyb-F.js.map
